@if(visible){
  <div class="modal-backdrop">
    <div class="modal-window" [style.max-width]="maxWidth || null">
      <div class="modal-content">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
}